import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class GroupSwitch extends Component {

  configure() {
    return super.configure();
  }

  initialize() {

    this.elements = $('.price-list-title');

    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    this.elements.on('click', (event) => {
      return this.onClick(event);
    });
  }

  onClick(event) {

    let element = $(event.currentTarget),
        icon = element.find('.fal'),
        groupId = element.data('groupId'),
        items = $('[data-group-id="'+ groupId +'"]:not(.price-list-title)');

    event.preventDefault();

    if (element.hasClass('is-active')) {
      element.removeClass('is-active');
      items.addClass('is-hidden');
      icon.removeClass('fa-angle-down').addClass('fa-angle-right');
    } else {
      element.addClass('is-active');
      items.removeClass('is-hidden');
      icon.removeClass('fa-angle-right').addClass('fa-angle-down');
    }


  }

}